import { Injectable, OnInit } from "@angular/core";
import { SideBarService } from "../../../shared/services/sideBarService";

@Injectable()
export class SignalsMainComponent implements OnInit {
  constructor(private sideBarService: SideBarService) {}

  ngOnInit(): void {
    this.sideBarService.setItems([
      { Text: "Messages", Url: "/tradingstudio/messages" },
      { Text: "Scheduled", Url: "/tradingstudio/scheduled" },
      { Text: "Signals", Url: "/tradingstudio/signals" },
      { Text: "Syncronize", Url: "/tradingstudio/signals/sync" },
      { Text: "Trade Plans", Url: "/tradingstudio/tradeplans" },
      { Text: "User Question", Url: "/tradingstudio/user-question" },
    ]);
  }
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/main.component.ts